export const GET_COW_DAILY_DETAILS_REQUEST = 'GET_COW_DAILY_DETAILS_REQUEST';
export const GET_COW_DAILY_DETAILS_REQUEST_SUCCESS =
  'GET_COW_DAILY_DETAILS_REQUEST_SUCCESS';
export const GET_COW_DAILY_DETAILS_REQUEST_ERROR = 'GET_COW_DAILY_DETAILS_REQUEST_ERROR';